import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';
import {
    Grid,
    Card,
    CardContent,
    Typography,
    LinearProgress,
    Table,
    Button,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Avatar,
} from '@material-ui/core';
import KeyboardArrowRightSharp from '@material-ui/icons/KeyboardArrowRightSharp';

import Loading from 'Console/components/common/loading/Loading';

const styles = (theme) => ({
    avatar: {
        color: '#fff',
        marginRight: theme.typography.pxToRem(10),
        backgroundColor: theme.palette.secondary.main,
        cursor: 'pointer',
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        [theme.breakpoints.down('sm')]: {
            'flex-direction': 'column',
        },
    },
    item: {
        [theme.breakpoints.down('sm')]: {
            'padding-top': theme.typography.pxToRem(5),
        },
    },
    tableTitles: {
        textAlign: 'left',
    },
    tableCell: {
        borderBottom: 'none',
        paddingTop: theme.typography.pxToRem(16),
        'word-break': 'break-word',
        [theme.breakpoints.up('sm')]: {
            '&:first-child': {
                'min-width': theme.typography.pxToRem(400),
            },
        },
    },
    noApplications: {
        width: '100%',
        height: 300,
        backgroundColor: 'white',
        marginTop: theme.typography.pxToRem(20),
    },
});

const ApplicationList = ({ classes, list, isLoading, pushToDetail }) => {
    if (isLoading) {
        return <Loading minHeight="300" />;
    }

    if (!isLoading && list && list.length === 0) {
        return (
            <Grid container justify="center" alignItems="center" className={classes.noApplications}>
                <Typography variant="body1">
                    <FormattedMessage
                        id="Applications.list.empty"
                        defaultMessage="Go ahead and create your first space"
                    />
                </Typography>
            </Grid>
        );
    }

    if (!isLoading && list && list.length > 0) {
        return (
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.tableTitles}>
                            <Typography variant="subtitle1">
                                <FormattedMessage id="General.name" defaultMessage="Name" />
                            </Typography>
                        </TableCell>
                        <TableCell className={classes.tableTitles} align="right">
                            <Typography variant="subtitle1">
                                <FormattedMessage id="General.domains" defaultMessage="Domains" />{' '}
                            </Typography>
                        </TableCell>
                        <TableCell className={classes.tableTitles} align="right">
                            <Typography variant="subtitle1">
                                <FormattedMessage id="General.actions" defaultMessage="Actions" />{' '}
                            </Typography>
                        </TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {list.map((row) => (
                        <TableRow key={row.id}>
                            <TableCell className={classes.tableCell} component="th" scope="row">
                                <Grid container wrap="nowrap" alignItems="center">
                                    <Avatar
                                        id="yeself-application-avatar"
                                        className={classes.avatar}
                                        onClick={pushToDetail(row.id)}
                                    >
                                        {row.name ? row.name.slice(0, 2).toUpperCase() : '?'}
                                    </Avatar>

                                    <b
                                        tabIndex={row.id}
                                        role="button"
                                        style={{ cursor: 'pointer' }}
                                        onClick={pushToDetail(row.id)}
                                    >
                                        {row.name}
                                    </b>
                                </Grid>
                            </TableCell>
                            <TableCell className={classes.tableCell}>
                                <Typography>{row.originUrls.join(',')}</Typography>
                            </TableCell>
                            <TableCell className={classes.tableCell}>
                                <Button
                                    id="yeself-application-action-button"
                                    size="small"
                                    onClick={pushToDetail(row.id)}
                                >
                                    <KeyboardArrowRightSharp />
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        );
    }

    return (
        <Card>
            <CardContent>
                <Grid container justify="center" alignContent="center">
                    <Grid container alignContent="flex-start">
                        <Grid item xs={12}>
                            <LinearProgress className="yeself-linear-loading" />
                        </Grid>
                        <Grid item xs={12}>
                            <LinearProgress className="yeself-linear-loading" />
                        </Grid>
                        <Grid item xs={6}>
                            <LinearProgress className="yeself-linear-loading" />
                        </Grid>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default withStyles(styles)(ApplicationList);
